// crear objetos sirve para nada mas que agrupar campos bajo un titulo en el boton de configuración de campos visibles.
export default function objectService() {
  return function generate(viewField, engineApi) {
    const element = engineApi.register.setCommonAttributes('ec-flex-rows', viewField, engineApi);
    // viewField.model && element.addAttribute('fb-register', engineApi.utils.getParent(viewField.model));
    viewField.model && element.addAttribute('fb-register', viewField.model);
    element.append(engineApi.handleProperties(viewField, engineApi));
    return element;
  };
}
